import React, { Suspense, useState } from 'react';
import { ConfigModel } from '@ibe/services';
import { useMount } from 'react-use';
import {
  ExternalSearchParams,
  ExternalSearchParamsContextProps,
  Overlay,
  OverlayContainer
} from '@ibe/components';
import initI18next from '../Translations/setup';
import Search from '../Components/Search';
import { ThgConfigModel } from '../Config/ThgConfigModel';
import '../Theme/Styles/searchWidget.scss';
import { bootMinimal } from '../Config/minimalConfig';
import { extendedConfigContext } from '../Config/extendedConfigContext';

const SearchWidget = (
  props: ExternalSearchParamsContextProps & {
    redirectUrl?: string;
    thgConfig: ThgConfigModel;
    configOverrides?: ConfigModel;
  }
) => {
  const {
    widgetSessionKeyPrefix: keyPrefix,
    redirectUrl,
    configOverrides,
    thgConfig,
    mode
  } = props;
  const [bootstrappingFinished, setBootstrappingFinished] = useState<boolean>(false);

  const widgetSessionKeyPrefix = keyPrefix || document.body.id || '';

  useMount(async () => {
    await initI18next(
      thgConfig.baseUrl,
      thgConfig.version,
      configOverrides?.tenant ?? undefined,
      mode
    );
    await bootMinimal(configOverrides, thgConfig);
    setBootstrappingFinished(true);
  });

  return bootstrappingFinished ? (
    <div style={{ backgroundColor: 'transparent' }} id="iso">
      <Suspense fallback={<LoadingPlaceHolder />}>
        <extendedConfigContext.Provider value={thgConfig}>
          <ExternalSearchParams {...props} widgetSessionKeyPrefix={widgetSessionKeyPrefix}>
            <Search redirectUrl={redirectUrl} />
          </ExternalSearchParams>
        </extendedConfigContext.Provider>
      </Suspense>
    </div>
  ) : (
    <LoadingPlaceHolder />
  );
};

export const LoadingPlaceHolder = () => {
  return (
    <OverlayContainer>
      <div id="iso" style={{ height: '100px' }}>
        <Overlay />
      </div>
    </OverlayContainer>
  );
};

export default SearchWidget;
